import { Form, Input, Button, Card, Space } from 'antd';
import TablePage from '../../../../../components/pages/TablePage';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { PostAPI } from '../../../../../redux';
import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import BarcodeReader from 'react-barcode-reader';

function PageScan() {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const [refresh, setRefresh] = useState(moment().unix());

    const columns = [
        { selector: (row) => row?.mawb_number, name: "MAWB" },
        { selector: (row) => row?.hawb_number, name: "HAWB" },
        { selector: (row) => row?.flight_number, name: "Flight Number" },
        { selector: (row) => row?.flight_date, name: "Flight Date" },
        { selector: (row) => row?.status, name: "Status" },
        { selector: (row) => row?.verified, name: "Verified" },
        {
            selector: (row) =>
                moment(row?.import_in_params?.wk_inout, "YYYYMMDDHHmmss").format('DD-MMM-YYYY'),
            name: "Date Gate In",
        },
    ];

    const handleSend = useCallback((data) => {
        const url = 'api/v1/tps_import_pjt/scan_gate_in';
        dispatch(PostAPI({ url, data })).then(resp => {
            if (resp?.payload) {
                setRefresh(moment().unix());
                toast.success("Send Gate In Success!");
            }
        });
        form.resetFields();
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100);
    }, [dispatch, form]);

    const handleBarcodeScan = (scannedValue) => {
        if (scannedValue) {
            handleSend({ barcode: scannedValue });
        }
    };

    useEffect(() => {
        inputRef.current?.focus();
    }, []);


    const conditionalRowStyles = [
        {
            when: row => row.status === 'Gate In',
            style: {
                backgroundColor: 'green',
                color: 'white',
            },
        },
    ];

    return (
        <>
            <BarcodeReader
                onScan={handleBarcodeScan}
                onError={(err) => console.error("Barcode scan error:", err)}
            />

            <Card title="Input / Scan HAWB" style={{ marginTop: 16 }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => handleSend(values)}
                >
                    <Form.Item
                        label="Input HAWB"
                        name="barcode"
                        rules={[{ required: true, message: 'Isi hawb terlebih dahulu.' }]}
                    >
                        <Input
                            ref={inputRef}
                            placeholder="isi hawb di sini"
                            onPressEnter={() => form.submit()}
                            autoComplete='off'
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                            <Button htmlType="button" onClick={() => form.resetFields()}>
                                Reset
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            <div style={{ marginTop: 20 }}>
                <TablePage
                    title="History Gate In"
                    url="api/v1/tps_import_pjt/import_in_history"
                    actionPosition="right"
                    columns={columns}
                    refresh={refresh}
                    conditionalRows={conditionalRowStyles}
                />
            </div>
        </>
    );
}

export default PageScan;
